import moment from "moment";
import {
  parseCategories,
  calPercentage,
  generateGfxCategories,
  generateGfxCategoriesPercentage,
  calcTotalStrikesThrown as calcStrikesThrown,
  calcTotalStrikesLanded as calcStrikesLanded,
} from "../../utils/CategoryUtils";

const CATEGORIES_CIQ = ["TOT", "ARM", "LEG", "GD", "TD", "KD", "SUB"];

const GFX_CATEGORIES_CIQ = [
  {
    name: "Arm Strikes",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[1] + ".Succ",
        missed: CATEGORIES_CIQ[1] + ".Att",
        stats: stats,
      });
    },
  },
  {
    name: "Leg Strikes",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[2] + ".Succ",
        missed: CATEGORIES_CIQ[2] + ".Att",
        stats: stats,
      });
    },
  },
  {
    name: "Ground Strikes",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[3] + ".Succ",
        missed: CATEGORIES_CIQ[3] + ".Att",
        stats: stats,
      });
    },
  },
  {
    name: "Knockdowns",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[5] + ".Succ",
        missed: CATEGORIES_CIQ[5] + ".Att",
        stats: stats,
      });
    },
  },
  {
    name: "Takedowns",
    stat: (stats) => {
      return calPercentageCIQ({
        landed: CATEGORIES_CIQ[4] + ".Succ",
        missed: CATEGORIES_CIQ[4] + ".Att",
        stats: stats,
      });
    },
  },
];

function calPercentageCIQ({ missed, landed, stats, round }) {
  let missed_total = stats
    ?.filter((r) => r?.round === round || !round)
    ?.reduce((prev, curr) => {
      var value = missed?.split(".").reduce((a, b) => a?.[b], curr);

      return prev + (value || 0);
    }, 0);
  let landed_total = stats
    ?.filter((r) => r?.round === round || !round)
    ?.reduce((prev, curr) => {
      var value = landed?.split(".").reduce((a, b) => a?.[b], curr);
      return prev + (value || 0);
    }, 0);
  let output = (landed_total || 0) + "/";

  output += (missed_total || 0) + (landed_total || 0);

  return output;
}

export class BottomLeftStatsALT {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "L3StatsALT";
    this.scene = "L3StatsALT";
    this.data = [];
    this.page = 9003;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      
      xml.payload.field.find((item) => {
        return item.attr.name === "1127";
      }).value = options?.game?.competition?.flag_path + 
      (options?.player?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1101";
      }).value = options?.player?.weightclass?.toUpperCase() || "";    

      xml.payload.field.find((item) => {
        return item.attr.name === "1100";
      }).value = (options?.player?.first_name.toUpperCase()  || "") + " " + (options?.player?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "2001";
      }).value = options?.corner || "";
      //TOTAL STRIKES
      const categories = options?.game?.competition?.categories;
      const GFX_CATEGORIES = generateGfxCategories(categories);
      const GFX_CATEGORIES_PERCENT = generateGfxCategoriesPercentage(categories);

      // Get selected stats order from localStorage (set by TeamStats component)
      let selectedStatsOrder = [];
      try {
        const stored = localStorage.getItem("cagenomics_stats_order");
        if (stored) {
          selectedStatsOrder = JSON.parse(stored);
        }
      } catch (err) {}

      // Helper to get category by selected name or fall back to index
      const getCategory = (index, categoriesArray) => {
        if (selectedStatsOrder.length > index) {
          const selectedName = selectedStatsOrder[index];
          const found = categoriesArray.find((c) => c.name === selectedName);
          if (found) return found;
        }
        return categoriesArray[index];
      };

      xml.payload.field.find((item) => {
        return item.attr.name === "1014";
      }).value = getCategory(0, GFX_CATEGORIES)?.name?.toUpperCase() || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "1016";
      }).value = getCategory(1, GFX_CATEGORIES)?.name?.toUpperCase() || "";

      xml.payload.field.find((item) => {
        return item.attr.name === "1018";
      }).value = getCategory(2, GFX_CATEGORIES)?.name?.toUpperCase() || "";

      // Category 1
      xml.payload.field.find((item) => {
        return item.attr.name === "1054";
      }).value =
        getCategory(0, GFX_CATEGORIES)?.stat(options?.stats) || "0/0";

      xml.payload.field.find((item) => {
        return item.attr.name === "1055";
      }).value =
        getCategory(0, GFX_CATEGORIES_PERCENT)?.stat(options?.stats) || "0";
      // Category 2
      xml.payload.field.find((item) => {
        return item.attr.name === "1056";
      }).value =
        getCategory(1, GFX_CATEGORIES)?.stat(options?.stats) || "0/0";

      xml.payload.field.find((item) => {
        return item.attr.name === "1057";
      }).value =
        getCategory(1, GFX_CATEGORIES_PERCENT)?.stat(options?.stats) || "0";

      // Category 3
      xml.payload.field.find((item) => {
        return item.attr.name === "1058";
      }).value =
        getCategory(2, GFX_CATEGORIES)?.stat(options?.stats) || "0/0";

      xml.payload.field.find((item) => {
        return item.attr.name === "1059";
      }).value =
        getCategory(2, GFX_CATEGORIES_PERCENT)?.stat(options?.stats) || "0";

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
